import React, { useState } from 'react';
import AboutModal from '../../../components/feature/AboutModal';
import KVKKModal from '../../../components/feature/KVKKModal';
import TermsModal from '../../../components/feature/TermsModal';
import PrivacyModal from '../../../components/feature/PrivacyModal';

const PrimeFooter: React.FC = () => {
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);
  const [isKVKKModalOpen, setIsKVKKModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  return (
    <>
      <footer className="relative overflow-hidden">
        {/* Ana Footer */}
        <div className="bg-gradient-to-br from-[#0B1D3A] via-[#0F2847] to-[#0B1D3A] text-white">
          <div className="max-w-7xl mx-auto px-6 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
              {/* Logo & Açıklama */}
              <div className="lg:col-span-1">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#C9A961] rounded-xl flex items-center justify-center">
                    <i className="ri-hotel-line text-2xl text-white"></i>
                  </div>
                  <span className="text-2xl font-bold">Prime Sales Pro</span>
                </div>
                <p className="text-gray-400 leading-relaxed mb-6">
                  Otel gelir yönetimi ve operasyonel verimlilik konusunda uzman çözüm ortağınız.
                </p>
                <div className="flex gap-3">
                  {[
                    { icon: 'ri-linkedin-fill', url: '#' },
                    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/primesalesprocom' },
                    { icon: 'ri-facebook-fill', url: '#' },
                  ].map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-white/5 hover:bg-[#D4AF37] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                    >
                      <i className={`${social.icon} text-lg`}></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* Çözümler */}
              <div>
                <h3 className="text-lg font-bold mb-6 text-[#D4AF37]">Çözümler</h3>
                <ul className="space-y-3">
                  {[
                    { label: 'Operasyonel Sistem', url: '#funnels' },
                    { label: 'Ticari Büyüme', url: '#funnel-ticari-buyume' },
                    { label: 'Revenue Management', url: '#' },
                    { label: 'PMS Entegrasyonu', url: '#' },
                  ].map((link, index) => (
                    <li key={index}>
                      <a
                        href={link.url}
                        className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-300 flex items-center gap-2 cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Şirket */}
              <div>
                <h3 className="text-lg font-bold mb-6 text-[#D4AF37]">Şirket</h3>
                <ul className="space-y-3">
                  <li>
                    <button
                      onClick={() => setIsAboutModalOpen(true)}
                      className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-300 flex items-center gap-2 cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line"></i>
                      Hakkımızda
                    </button>
                  </li>
                  {[
                    { label: 'İş Ortaklarımız', url: '#references' },
                    { label: 'Blog', url: '#' },
                    { label: 'Kariyer', url: '#' },
                  ].map((link, index) => (
                    <li key={index}>
                      <a
                        href={link.url}
                        className="text-gray-400 hover:text-[#D4AF37] transition-colors duration-300 flex items-center gap-2 cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* İletişim */}
              <div>
                <h3 className="text-lg font-bold mb-6 text-[#D4AF37]">İletişim</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-gray-400">
                    <i className="ri-phone-line text-[#D4AF37] text-xl mt-0.5"></i>
                    <div>
                      <a href="tel:+905524400989" className="hover:text-[#D4AF37] transition-colors cursor-pointer">
                        +90 552 440 09 89
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3 text-gray-400">
                    <i className="ri-mail-line text-[#D4AF37] text-xl mt-0.5"></i>
                    <div>
                      <a href="mailto:sales@primesalespro.com" className="hover:text-[#D4AF37] transition-colors cursor-pointer">
                        sales@primesalespro.com
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3 text-gray-400">
                    <i className="ri-map-pin-line text-[#D4AF37] text-xl mt-0.5"></i>
                    <div>
                      <p>İstanbul, Türkiye</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Alt Bilgi */}
            <div className="border-t border-white/10 pt-8">
              <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-gray-400 text-sm">
                  PrimeSalesPro © Tüm hakları saklıdır.
                </p>
                <div className="flex gap-6">
                  <button
                    onClick={() => setIsPrivacyModalOpen(true)}
                    className="text-gray-400 hover:text-[#D4AF37] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Gizlilik Politikası
                  </button>
                  <button
                    onClick={() => setIsTermsModalOpen(true)}
                    className="text-gray-400 hover:text-[#D4AF37] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Kullanım Koşulları
                  </button>
                  <button
                    onClick={() => setIsKVKKModalOpen(true)}
                    className="text-gray-400 hover:text-[#D4AF37] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    KVKK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <AboutModal isOpen={isAboutModalOpen} onClose={() => setIsAboutModalOpen(false)} />
      <KVKKModal isOpen={isKVKKModalOpen} onClose={() => setIsKVKKModalOpen(false)} />
      <TermsModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} />
      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} />
    </>
  );
};

export default PrimeFooter;
